



































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { BillingInfoResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import BillingInfoEditForm from '@/modules/billing-info/components/panel/BillingInfoEditForm.vue'

@Component({
  components: { BillingInfoEditForm, Modal, BaseButton, AlertNotification }
})
export default class BillingInfoAlert extends Vue {
  @Prop({ required: true }) billingInfo!: BillingInfoResourceModel

  private showEditModal = false

  get billingName() {
    return this.billingInfo.type === BillingInfoType.LEGAL ?
      this.billingInfo.legal_name : this.billingInfo.natural_name
  }

  get personType() {
    return 'حقیقی'//this.billingInfo.type === BillingInfoType.LEGAL ? 'حقوقی' : 'حقیقی'
  }
}
